import { useEffect, useRef } from 'react'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../constants/common'
import { EVENT_NAME_VISIBILITY_CHANGE } from '../../constants/event'

import { RELOAD_ON_TAB_RETURN_MIN_INTERVAL } from './useReloadOnTabReturn.constants'

export function useReloadOnTabReturn({
  minInterval = RELOAD_ON_TAB_RETURN_MIN_INTERVAL,
  onReload = EMPTY_FUNCTION,
} = EMPTY_OBJECT) {
  const lastReloadTimeRef = useRef(0)

  useEffect(() => {
    function handleVisibilityChange() {
      const isReturnedToTab = document.visibilityState === 'visible'

      const isThrottled = Date.now() - lastReloadTimeRef.current < minInterval

      if (isReturnedToTab && !isThrottled) {
        lastReloadTimeRef.current = Date.now()

        onReload()
      }
    }

    document.addEventListener(
      EVENT_NAME_VISIBILITY_CHANGE,
      handleVisibilityChange
    )

    return () => {
      document.removeEventListener(
        EVENT_NAME_VISIBILITY_CHANGE,
        handleVisibilityChange
      )
    }
  }, [minInterval, onReload])
}
